<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="5 5 17 17">
    <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.25">
      <path d="M10.667 9.934h-2.5A1.667 1.667 0 0 0 6.5 11.601v7.5a1.667 1.667 0 0 0 1.667 1.667h7.5a1.667 1.667 0 0 0 1.667-1.667v-2.5"/>
      <path d="M10.667 16.601h2.5l7.083-7.08a1.768 1.768 0 0 0-2.5-2.5l-7.083 7.08v2.5"/>
      <path d="m16.5 8.268 2.5 2.5"/>
    </g>
  </svg>
</template>
